import { getConfig } from '../Config/ApplicationConfig';
import { getExecutor } from '../Shared/HttpRequestExecutor';
export var searchAtcCodes = function (config, query, limit) {
    if (query === void 0) { query = ''; }
    if (limit === void 0) { limit = 0; }
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).getCancellable("api/v1/references/atc/search?query=" + query + "&limit=" + limit, config);
};
export var searchPoisonSchedules = function (config, query, limit) {
    if (query === void 0) { query = ''; }
    if (limit === void 0) { limit = 0; }
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).getCancellable("api/v1/references/poison-schedule/search?query=" + query + "&limit=" + limit, config);
};
export var searchMedicinalProducts = function (config, query, limit) {
    if (query === void 0) { query = ''; }
    if (limit === void 0) { limit = 0; }
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).getCancellable("api/v1/references/medicinal-product/search?query=" + query + "&limit=" + limit, config);
};
